import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/index';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { ContentProvider } from './ContentProvider';
import { DatesProvider } from './DatesProvider';
import { Loading } from '@/components/ui/loading/Loading';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<Provider store={store}>
			<MantineProvider>
				<QueryProvider>
					<ContentProvider>
						<DatesProvider>
							<Suspense fallback={<Loading />}>{children}</Suspense>
						</DatesProvider>
					</ContentProvider>
				</QueryProvider>
			</MantineProvider>
		</Provider>
	);
};
